import { Checkbox, FormControlLabel } from '@mui/material';
import { InfoIconTooltip } from '../ui-control/InfoIconTooltip';
import FileButtonOptions from './fileButtonOption';
import { useDownloadOptions } from '../../hooks/useDownloadOptions';
import useLiabilityFileUpload from '../../hooks/useLiabilityFileUpload';
import { getDefendantId, getDefendantName } from '../../utils/helper';
import Constants from '../../Constants';
import { useAddCaseFormContext } from '../../contexts/AddCaseFormContext';
import { FaRegFileAlt } from "react-icons/fa";
import { badStatusFileError } from '../../utils/constant';
import FileUploadErrorModal from '../../utils/fileUploadErrorModal';
import UploadButtonGroup from './UploadButtonGroup';
import { reportItemClasses, reportBtnClasses } from './listItemClasses';
import { reportSectionClasses } from './formClasses';

const defendantCheckboxWrapClasses = 'ml-4! pl-4! flex items-center gap-2 max-w-[calc(var(--spacing)*150)] w-full overflow-auto';
const defendantCheckboxClasses = 'border border-primary rounded-[calc(var(--spacing)*2.5)] px-1.25 bg-primary-surface [&_span]:whitespace-nowrap [&_span]:text-primary';

const LiabilityFileUpload = ({
  fileType,
  label,
  uploadButtonText = 'Upload File',
  disabled = false,
  accept = 'application/pdf',
  multiple = true
}) => {
  const { downloadSingleFile } = useDownloadOptions();
  const { isBadRecord } = useAddCaseFormContext();

  const {
    fileArray,
    defendants,
    isSingleLiability,
    isShowTooltip,
    isLoading,
    fileErrorList,
    setFileErrorList,
    handleLiabilityFileUpload,
    handleDropboxSuccess,
    handleLiabilityFileRemove,
    updateLiabilityDefendants
  } = useLiabilityFileUpload({ fileType, accept });

  return (
    <div className={reportSectionClasses}>
      <div className={`${reportBtnClasses} p-6 mb-0!`}>
        <span>
          {label}
          <InfoIconTooltip isShow={isShowTooltip} message={Constants.ToolTips.liabilityFile} />
        </span>
        <UploadButtonGroup
          uploadButtonText={uploadButtonText}
          uploadButtonProps={{ variant: 'link' }}
          accept={accept}
          multiple={multiple}
          disabled={disabled}
          isLoading={isLoading}
          onFileSelect={(files) => handleLiabilityFileUpload({ files })}
          onDropboxSuccess={handleDropboxSuccess}
        />
      </div>
      {fileArray.length > 0 && fileArray.map((file, i) => (
        <div key={i} className={`${reportItemClasses} mx-3 mb-3 ${isBadRecord(file.s3UrlPath) ? 'text-danger border border-danger' : ''}`}>
          <div className="flex items-center gap-2 whitespace-nowrap">
            <div className='grow'>
              <FaRegFileAlt size={18} />
            </div>
            {(defendants?.length > 0 && !file.s3UrlPath) ? file.file?.name : file?.name} 
            <InfoIconTooltip isShow={isBadRecord(file.s3UrlPath)} message={badStatusFileError} isError={true}/>
            {defendants?.length > 0 && (
              <div className={defendantCheckboxWrapClasses}>
                {defendants.map((defendant, index) => (
                  <FormControlLabel
                    key={getDefendantId(defendant) + index}
                    className={getDefendantName(defendant) !== '' ? defendantCheckboxClasses : ''}
                    label={getDefendantName(defendant)}
                    control={
                      !isSingleLiability ? (
                        <Checkbox
                          checked={file.defendants?.includes(getDefendantId(defendant))}
                          onChange={(e) => updateLiabilityDefendants({ s3UrlPath: file.s3UrlPath, defendantId: getDefendantId(defendant), isChecked: e.target.checked })}
                        />
                      ) : <></>
                    }
                  />
                ))}
              </div>
            )}
          </div>
          <FileButtonOptions
            divClassName='flex items-center'
            onDownload={() => downloadSingleFile(file)}
            onDelete={() => handleLiabilityFileRemove({ fileToRemove: file })}
            isLoading={isLoading}
          />
        </div>
      ))}
      {fileErrorList.length > 0 && (
        <FileUploadErrorModal
          fileErrorList={fileErrorList}
          setFileErrorList={setFileErrorList}
        />
      )}
    </div>
  );
};

export default LiabilityFileUpload;
